export enum NoteMenuActions {
  EDIT = 'edit',
  DELETE = 'delete',
}
